import * as React from 'react';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';
import { LeftIconWrapper } from '../styled';

import { DeliveryDate, DeliveryInfoWrapper, Name } from './styled';

interface IDeliveryLineProps {
  showIcon: boolean;
  icon: JSX.Element;
  name: string;
  description: JSX.Element | string;
  isInactive: boolean;
}

export const DeliveryLine: React.FC<IDeliveryLineProps> = ({
  showIcon,
  icon,
  name,
  description,
  isInactive,
}) => {
  const newPdDesignEnabled = useNewPdDesignEnabled();

  return (
    <>
      <LeftIconWrapper>
        {showIcon &&
          React.cloneElement(icon, {
            color: isInactive ? 'icon.disabled' : 'icon.primary',
            width: '20px',
            height: '20px',
          })}
      </LeftIconWrapper>

      <DeliveryInfoWrapper newDesign={newPdDesignEnabled}>
        <Name isInactive={isInactive} newPdDesignEnabled={newPdDesignEnabled}>
          {name}
        </Name>

        <DeliveryDate
          isInactive={isInactive}
          newPdDesignEnabled={newPdDesignEnabled}
        >
          {description}
        </DeliveryDate>
      </DeliveryInfoWrapper>
    </>
  );
};
